import { ArrowRight, Scale, BarChart3 } from "lucide-react";
import { Container, Eyebrow, Section, Reveal } from "./common";
import { MOTORS } from "../data/content";

export const TresMotores = () => {
  return (
    <Section id="ecosistema">
      <Container>
        <Reveal>
          <Eyebrow>Qué es Raíz Commerce · en una frase</Eyebrow>
          <p className="mt-6 max-w-4xl font-serif font-light text-2xl sm:text-3xl leading-snug text-stone-200">
            Raíz Commerce convierte el <span className="text-rc-sage italic">aislamiento del territorio</span> en
            su principal activo de mercado. No produce café, no tala madera, no opera hoteles:
            produce <span className="text-rc-sage italic">sistemas de gobernanza</span> que hacen a un territorio
            legible, medible y financiable para el capital.
          </p>
        </Reveal>

        <div className="mt-20">
          <Reveal>
            <Eyebrow>La arquitectura</Eyebrow>
            <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
              Tres motores, <span className="text-rc-sage italic">una sola arquitectura</span>
            </h2>
            <p className="mt-6 max-w-2xl text-stone-400 font-light leading-relaxed">
              Un territorio no avanza porque cada actor optimice su parcela. Avanza cuando el comercio,
              la circularidad y el turismo funcionan como un mismo circuito — con una gobernanza que los
              vincula y un método que verifica el impacto.
            </p>
          </Reveal>

          <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
            {MOTORS.map((m, i) => (
              <Reveal key={m.n} delay={i * 0.1}>
                <div className="group h-full p-8 md:p-10 rounded-2xl bg-rc-card border border-rc-border hover:border-rc-sage/40 transition-all duration-300">
                  <div className="font-mono text-sm text-rc-terra tracking-widest">MOTOR {m.n}</div>
                  <div className="mt-6 flex items-center justify-between">
                    <h3 className="font-serif text-2xl text-stone-100">{m.title}</h3>
                    <ArrowRight className="w-5 h-5 text-rc-sage/50 group-hover:translate-x-1 transition-transform" />
                  </div>
                  <p className="mt-4 text-stone-400 font-light leading-relaxed">{m.text}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-8 grid md:grid-cols-2 gap-6 lg:gap-8">
            <Reveal>
              <div className="h-full p-8 md:p-10 rounded-2xl bg-gradient-to-br from-rc-forest/20 to-rc-card border border-rc-border">
                <Scale className="w-6 h-6 text-rc-sage" strokeWidth={1.5} />
                <div className="mt-4 rc-eyebrow">Lo que los mantiene unidos</div>
                <h3 className="mt-3 font-serif text-xl text-stone-100">Gobernanza territorial vinculante</h3>
                <p className="mt-3 text-stone-400 font-light leading-relaxed">
                  Una figura de gobernanza propia — el Comité Territorial Regenerativo (CTR) — articula a
                  los actores del territorio para que decidan y operen como un solo sistema, más allá de los
                  cambios de administración.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="h-full p-8 md:p-10 rounded-2xl bg-gradient-to-br from-rc-terra/15 to-rc-card border border-rc-border">
                <BarChart3 className="w-6 h-6 text-rc-sand" strokeWidth={1.5} />
                <div className="mt-4 rc-eyebrow">Lo que lo hace verificable</div>
                <h3 className="mt-3 font-serif text-xl text-stone-100">Impacto medido, no prometido</h3>
                <p className="mt-3 text-stone-400 font-light leading-relaxed">
                  Raíz Carbono es el brazo técnico que mide y verifica el impacto ambiental del sistema.
                  El resultado se comprueba con datos, bajo estándares reconocidos.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </Container>
    </Section>
  );
};
